
<template>
  <div class="atividades-sinistros ml-4 mr-4">
    <b-form>
      <b-row>
        <!-- -->
        <!-- -->
        <b-col cols="4">
          <label for="select-empresa-cor">Empresa</label>
          <multiselect
            id="selecao-empresa-cor-ind"
            v-model="empresaf"
            :options="empresasf"
            :multiple="true"
            :close-on-select="false"
            :clear-on-select="true"
            @close="loadFiliais()"
            :preserve-search="true"
            placeholder="Selecione a empresa"
            label="nomeempresarial"
            track-by="nomeempresarial"
            name="nomeempresarial"
          >
            <template slot="selection" slot-scope="{ values, isOpen }"
              ><span
                class="multiselect__single"
                v-if="values.length &amp;&amp; !isOpen"
                >{{ values.length }} Empresa selecionada</span
              ></template
            >
          </multiselect>
        </b-col>

        <b-col cols="4">
          <label for="select-filial_cor">Filial</label>
          <multiselect
            id="selecao-filial-coe-ind"
            v-model="filialf"
            :options="filiaisf"
            :multiple="true"
            @close="loadStatus()"
            :close-on-select="false"
            :clear-on-select="false"
            :preserve-search="true"
            placeholder="Selecione a filial"
            label="filial"
            track-by="filial"
            name="filial"
            :preselect-first="true"
          >
            <template slot="selection" slot-scope="{ values, isOpen }"
              ><span
                class="multiselect__single"
                v-if="values.length &amp;&amp; !isOpen"
                >{{ values.length }} Filial selecionada</span
              ></template
            >
          </multiselect>
        </b-col>

        <b-col cols="2">
          <label for="select-tpcorretiva-ind">Status do pneu</label>
          <multiselect
            v-model="sta"
            :options="statuss"
            :multiple="true"
            :close-on-select="false"
            :clear-on-select="false"
            :preserve-search="true"
            placeholder="Selecione o status"
            label="status"
            track-by="status"
            name="status"
            :preselect-first="true"
          >
            <template slot="selection" slot-scope="{ values, isOpen }"
              ><span
                class="multiselect__single"
                v-if="values.length &amp;&amp; !isOpen"
                >{{ values.length }} Status selecionado</span
              ></template
            >
          </multiselect>
        </b-col>
        <!--

              <b-col cols="1">
                <div>                            
                  <label  for="datepicker-placeholder">Data inicial</label>                        
                  <b-form-datepicker id="dt_sol_inicial"  required  v-model="dt_inicial"  placeholder="Data inicial " locale="pt-BR" date-format-options="DD/MM/YYYY"></b-form-datepicker>
                </div>                     
              </b-col>

              <b-col cols="1">
                <div>                            
                  <label  for="datepicker-placeholder">Data final</label>
                  <b-form-datepicker id="dt_sol_final"  required  v-model="dt_final"  placeholder="Data do final" locale="pt-BR" date-format-options="DD/MM/YYYY"></b-form-datepicker>
                </div>                     
              </b-col>

    -->
        <!-- condicional para exibir o botão planilha-->
        <b-col cols="2">
          <br />
          <b-button
            variant="success"
            class="mr-2 mt-2"
            block
            @click="
              loadKpiResumo(),
                loadKpiVida(),
                loadKpiMedida(),
                loadKpiBorracha(),
                loadKpiFabricante(),
                loadKpiStatus(),
                loadKpiFilial()
            "
          >
            Carregar indicadores
          </b-button>
        </b-col>
      </b-row>
    </b-form>

    <div>
      <b-row>
        <b-card-group class="ml-3 mt-3 mb-3 d-flex justify-content-center" deck>
          <b-card
            class="ml-2"
            style="width: 33rem"
            border-variant="primary"
            header="ESTOQUE"
            header-bg-variant="primary"
            header-text-variant="white"
            align="center"
          >
            <b-card-text>
              <h2>
                {{ kpiresumo.filter((s) => s.status_id === 1).length }}
              </h2>
            </b-card-text>
          </b-card>

          <b-card
            class="mr-2"
            style="width: 33rem"
            border-variant="primary"
            header="RODANDO"
            header-bg-variant="warning"
            header-text-variant="white"
            align="center"
          >
            <b-card-text>
              <h2>
                {{ kpiresumo.filter((s) => s.status_id === 2).length }}
              </h2>
            </b-card-text>
          </b-card>

          <b-card
            class="mr-2"
            style="width: 33rem"
            border-variant="primary"
            header="RECAPADORA"
            header-bg-variant="success"
            header-text-variant="white"
            align="center"
          >
            <b-card-text>
              <h2>
                {{ kpiresumo.filter((s) => s.status_id === 3).length }}
              </h2>
            </b-card-text>
          </b-card>

          <b-card
            class="mr-2"
            style="width: 33rem"
            border-variant="primary"
            header="SUCATA"
            header-bg-variant="success"
            header-text-variant="white"
            align="center"
          >
            <b-card-text>
              <h2>
                {{ kpiresumo.filter((s) => s.status_id === 5).length }}
              </h2>
            </b-card-text>
          </b-card>

          <b-card
            class="ml-2"
            style="width: 33rem"
            border-variant="primary"
            header="QUANTIDADE TOTAL  "
            header-bg-variant="danger"
            header-text-variant="white"
            align="center"
          >
            <b-card-text>
              <h2>
                {{ kpiresumo.length }}
              </h2>
            </b-card-text>
          </b-card>

          <b-card
            class="ml-2"
            style="width: 33rem"
            border-variant="primary"
            header="VALOR TOTAL  R$"
            header-bg-variant="danger"
            header-text-variant="white"
            align="center"
          >
            <b-card-text>
              <h2>
                <!-- {{ kpiresumo.reduce((acc, s) => acc + (parseFloat(s.valor) || 0), 0) }} -->
                {{
                  kpiresumo
                    .reduce((total, item) => total + parseFloat(item.valor), 0)
                    .toLocaleString("pt-BR", {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })
                }}
              </h2>
            </b-card-text>
          </b-card>
        </b-card-group>
      </b-row>
    </div>

    <!-- Painel -->
    <!-- Painel -->
    <!-- Painel -->

    <template>
      <div>
        <b-row>
          <!-- MEDIDA  -->
          <b-col cols="6" class="mt-4" id="grafdia">
            <apexcharts
              ref="chartmedida"
              height="400"
              :options="graficoMedida"
              :series="seriesmedidas"
            >
            </apexcharts>
          </b-col>

          <!-- VIDA  -->
          <b-col cols="6" class="mt-4" id="grafdia">
            <apexcharts
              ref="chartvida"
              height="400"
              :options="graficoVida"
              :series="seriesvidas"
            >
            </apexcharts>
          </b-col>
        </b-row>

        <!-- acumulado  -->
        <b-row>
          <!-- acumulado  FILIAL -->
          <b-col cols="3">
            <apexcharts
              ref="chart"
              height="400"
              :options="graficoPizzaFilial"
              :series="graficoPizzaFilial.series"
            >
            </apexcharts>
          </b-col>

          <!-- acumulado  borracha
           -->
          <b-col cols="3">
            <apexcharts
              ref="chartborrachas"
              height="400"
              :options="graficoBorracha"
              :series="seriesborrachas"
            ></apexcharts>
          </b-col>

          <!-- acumulado  fabricante -->
          <b-col cols="3">
            <apexcharts
              ref="chartfabricante"
              height="400"
              :options="graficoFabricante"
              :series="seriesfabricantes"
            ></apexcharts>
          </b-col>

          <!-- acumulado  status -->
          <b-col cols="3">
            <apexcharts
              ref="chartstatus"
              height="400"
              :options="graficoStatus"
              :series="seriesstatus"
            ></apexcharts>
          </b-col>
        </b-row>
      </div>
    </template>

    <!-- Painel -->
    <!-- Painel -->
    <!-- Painel -->
  </div>
</template>


<script>
import { baseApiUrl, showError } from "@/global";
import axios from "axios";
import Multiselect from "vue-multiselect";
import moment, { now } from "moment";
import { mapState } from "vuex";
import VueApexCharts from "vue-apexcharts";
import { onBeforeUpdate } from "vue";

export default {
  name: "SolicitacaoPainel",

  components: {
    apexcharts: VueApexCharts,
    Multiselect,
  },
  computed: { ...mapState(["user"]) },

  data: function () {
    return {
      /* Tipo de MEDIDA */

      /* MEDIDA */
      graficoMedida: {
        chart: {
          id: "bar-funcionario",
          type: "bar",
          height: 350,
          foreColor: "black",
          toolbar: {
            show: false,
          },
        },
        plotOptions: {
          bar: {
            horizontal: true,
            dataLabels: {
              position: "top", // Posição dos valores acima das barras
              offsetX: 10, // Ajusta a posição horizontal dos valores fora da barra
              offsetY: 0, // Ajusta a posição vertical dos valores fora da barra
            },
          },
        },
        dataLabels: {
          enabled: true, // Habilita os data labels
          offsetX: 10, // Ajusta a posição horizontal dos labels fora da barra
          style: {
            fontSize: "18px", // Aumenta o tamanho da fonte dos valores
            colors: ["#000000"], // Cor dos valores
          },
        },
        xaxis: {
          categories: [],
          tickPlacement: "on", // Alinha as categorias com as barras
        },
        yaxis: {
          labels: {
            style: {
              fontSize: "18px", // Tamanho da fonte do rótulo do eixo Y
              colors: "#000000", // Cor do rótulo do eixo Y
            },
          },
        },
        title: {
          text: "Medida",
          align: "center",
          margin: 10,
          offsetX: 0,
          offsetY: 0,
          floating: false,
          style: {
            fontSize: "22px",
            fontWeight: "bold",
            color: "#263238",
          },
        },
        legend: {
          position: "top", // Alinha a legenda no topo
          horizontalAlign: "center", // Alinha a legenda horizontalmente no centro
          floating: false, // Define se a legenda deve flutuar ou não
          offsetY: 0, // Ajusta a posição vertical da legenda
          labels: {
            style: {
              fontSize: "14px", // Tamanho da fonte da legenda
              colors: ["#000000"], // Cor da fonte da legenda
            },
          },
        },
      },

      /* VIDA */
      graficoVida: {
        chart: {
          id: "bar-funcionario",
          type: "bar",
          height: 350,
          foreColor: "black",
          toolbar: {
            show: false,
          },
        },
        plotOptions: {
          bar: {
            horizontal: true,
            dataLabels: {
              position: "top", // Posição dos valores acima das barras
              offsetX: 10, // Ajusta a posição horizontal dos valores fora da barra
              offsetY: 0, // Ajusta a posição vertical dos valores fora da barra
            },
          },
        },
        dataLabels: {
          enabled: true, // Habilita os data labels
          offsetX: 10, // Ajusta a posição horizontal dos labels fora da barra
          style: {
            fontSize: "18px", // Aumenta o tamanho da fonte dos valores
            colors: ["#000000"], // Cor dos valores
          },
        },
        xaxis: {
          categories: [],
          tickPlacement: "on", // Alinha as categorias com as barras
        },
        yaxis: {
          labels: {
            style: {
              fontSize: "18px", // Tamanho da fonte do rótulo do eixo Y
              colors: "#000000", // Cor do rótulo do eixo Y
            },
          },
        },
        title: {
          text: "Vida",
          align: "center",
          margin: 10,
          offsetX: 0,
          offsetY: 0,
          floating: false,
          style: {
            fontSize: "22px",
            fontWeight: "bold",
            color: "#263238",
          },
        },
        legend: {
          position: "top", // Alinha a legenda no topo
          horizontalAlign: "center", // Alinha a legenda horizontalmente no centro
          floating: false, // Define se a legenda deve flutuar ou não
          offsetY: 0, // Ajusta a posição vertical da legenda
          labels: {
            style: {
              fontSize: "14px", // Tamanho da fonte da legenda
              colors: ["#000000"], // Cor da fonte da legenda
            },
          },
        },
      },

      /* borracha    */
      graficoBorracha: {
        chart: {
          id: "bar-funcionario",
          type: "bar",
          height: 350,
          foreColor: "black",
          toolbar: {
            show: false,
          },
        },
        plotOptions: {
          bar: {
            horizontal: true,
            dataLabels: {
              position: "top", // Posição dos valores acima das barras
              offsetX: 10, // Ajusta a posição horizontal dos valores fora da barra
              offsetY: 0, // Ajusta a posição vertical dos valores fora da barra
            },
          },
        },
        dataLabels: {
          enabled: true, // Habilita os data labels
          offsetX: 10, // Ajusta a posição horizontal dos labels fora da barra
          style: {
            fontSize: "18px", // Aumenta o tamanho da fonte dos valores
            colors: ["#000000"], // Cor dos valores
          },
        },
        xaxis: {
          categories: [],
          tickPlacement: "on", // Alinha as categorias com as barras
        },
        yaxis: {
          labels: {
            style: {
              fontSize: "18px", // Tamanho da fonte do rótulo do eixo Y
              colors: "#000000", // Cor do rótulo do eixo Y
            },
          },
        },
        title: {
          text: "Borracha",
          align: "center",
          margin: 10,
          offsetX: 0,
          offsetY: 0,
          floating: false,
          style: {
            fontSize: "22px",
            fontWeight: "bold",
            color: "#263238",
          },
        },
        legend: {
          position: "top", // Alinha a legenda no topo
          horizontalAlign: "center", // Alinha a legenda horizontalmente no centro
          floating: false, // Define se a legenda deve flutuar ou não
          offsetY: 0, // Ajusta a posição vertical da legenda
          labels: {
            style: {
              fontSize: "14px", // Tamanho da fonte da legenda
              colors: ["#000000"], // Cor da fonte da legenda
            },
          },
        },
      },

      /* fabricante    */
      graficoFabricante: {
        chart: {
          id: "bar-funcionario",
          type: "bar",
          height: 350,
          foreColor: "black",
          toolbar: {
            show: false,
          },
        },
        plotOptions: {
          bar: {
            horizontal: true,
            dataLabels: {
              position: "top", // Posição dos valores acima das barras
              offsetX: 10, // Ajusta a posição horizontal dos valores fora da barra
              offsetY: 0, // Ajusta a posição vertical dos valores fora da barra
            },
          },
        },
        dataLabels: {
          enabled: true, // Habilita os data labels
          offsetX: 10, // Ajusta a posição horizontal dos labels fora da barra
          style: {
            fontSize: "18px", // Aumenta o tamanho da fonte dos valores
            colors: ["#000000"], // Cor dos valores
          },
        },
        xaxis: {
          categories: [],
          tickPlacement: "on", // Alinha as categorias com as barras
        },
        yaxis: {
          labels: {
            style: {
              fontSize: "18px", // Tamanho da fonte do rótulo do eixo Y
              colors: "#000000", // Cor do rótulo do eixo Y
            },
          },
        },
        title: {
          text: "Fabricante",
          align: "center",
          margin: 10,
          offsetX: 0,
          offsetY: 0,
          floating: false,
          style: {
            fontSize: "22px",
            fontWeight: "bold",
            color: "#263238",
          },
        },
        legend: {
          position: "top", // Alinha a legenda no topo
          horizontalAlign: "center", // Alinha a legenda horizontalmente no centro
          floating: false, // Define se a legenda deve flutuar ou não
          offsetY: 0, // Ajusta a posição vertical da legenda
          labels: {
            style: {
              fontSize: "14px", // Tamanho da fonte da legenda
              colors: ["#000000"], // Cor da fonte da legenda
            },
          },
        },
      },

      /* filial */
      //graficoPizzaFilial: {
      graficoPizzaFilial: {
        chart: {
          id: "bar-funcionario",
          type: "pie",
          height: 350,
          foreColor: "black",
          toolbar: {
            show: false,
          },
        },
        plotOptions: {
          bar: {
            horizontal: true,
            dataLabels: {
              position: "top", // Posição dos valores acima das barras
              offsetX: 10, // Ajusta a posição horizontal dos valores fora da barra
              offsetY: 0, // Ajusta a posição vertical dos valores fora da barra
            },
          },
        },
        dataLabels: {
          enabled: true, // Habilita os data labels
          offsetX: 10, // Ajusta a posição horizontal dos labels fora da barra
          style: {
            fontSize: "18px", // Aumenta o tamanho da fonte dos valores
            colors: ["#000000"], // Cor dos valores
          },
        },
        xaxis: {
          categories: [],
          tickPlacement: "on", // Alinha as categorias com as barras
        },
        yaxis: {
          labels: {
            style: {
              fontSize: "18px", // Tamanho da fonte do rótulo do eixo Y
              colors: "#000000", // Cor do rótulo do eixo Y
            },
          },
        },
        title: {
          text: "Filial",
          align: "center",
          margin: 10,
          offsetX: 0,
          offsetY: 0,
          floating: false,
          style: {
            fontSize: "22px",
            fontWeight: "bold",
            color: "#263238",
          },
        },
        legend: {
          position: "top", // Alinha a legenda no topo
          horizontalAlign: "center", // Alinha a legenda horizontalmente no centro
          floating: false, // Define se a legenda deve flutuar ou não
          offsetY: 0, // Ajusta a posição vertical da legenda
          labels: {
            style: {
              fontSize: "14px", // Tamanho da fonte da legenda
              colors: ["#000000"], // Cor da fonte da legenda
            },
          },
        },
      },

      /* status */
      graficoStatus: {
        chart: {
          id: "bar-funcionario",
          type: "bar",
          height: 350,
          foreColor: "black",
          toolbar: {
            show: false,
          },
        },
        plotOptions: {
          bar: {
            horizontal: true,
            dataLabels: {
              position: "top", // Posição dos valores acima das barras
              offsetX: 10, // Ajusta a posição horizontal dos valores fora da barra
              offsetY: 0, // Ajusta a posição vertical dos valores fora da barra
            },
          },
        },
        dataLabels: {
          enabled: true, // Habilita os data labels
          offsetX: 10, // Ajusta a posição horizontal dos labels fora da barra
          style: {
            fontSize: "18px", // Aumenta o tamanho da fonte dos valores
            colors: ["#000000"], // Cor dos valores
          },
        },
        xaxis: {
          categories: [],
          tickPlacement: "on", // Alinha as categorias com as barras
        },
        yaxis: {
          labels: {
            style: {
              fontSize: "18px", // Tamanho da fonte do rótulo do eixo Y
              colors: "#000000", // Cor do rótulo do eixo Y
            },
          },
        },
        title: {
          text: "Status",
          align: "center",
          margin: 10,
          offsetX: 0,
          offsetY: 0,
          floating: false,
          style: {
            fontSize: "22px",
            fontWeight: "bold",
            color: "#263238",
          },
        },
        legend: {
          position: "top", // Alinha a legenda no topo
          horizontalAlign: "center", // Alinha a legenda horizontalmente no centro
          floating: false, // Define se a legenda deve flutuar ou não
          offsetY: 0, // Ajusta a posição vertical da legenda
          labels: {
            style: {
              fontSize: "14px", // Tamanho da fonte da legenda
              colors: ["#000000"], // Cor da fonte da legenda
            },
          },
        },
      },

      empresaf: "",
      empresasf: [], // [] lista
      filialf: "",
      sta: "",
      filiaisf: [], // [] lista
      tipo: "",
      statuss: [],

      /* objetos */
      kpiresumo: [],
      kpividas: [],
      seriesvidas: [],

      kpifabricantes: [],
      seriesfabricantes: [],

      kpimedidas: [],
      seriesmedidas: [],

      kpiborrachas: [],
      seriesborrachas: [],

      kpistatus: [],
      seriesstatus: [],

      kpisfilial: [],
      seriesfilial: [],

      statuss: [],

      kpimkbf: [],
      kpiqtds: [],

      kpidias: [],
      kpifuncionario: [],
      kpilinha: [],
      kpicarro: [],
      seriestipo: [],
      seriesdia: [],
      seriesfuncionario: [],
      serieslinha: [],
      seriescarro: [],

      dt_inicial: "",
      dt_final: "",

      sinistros: [],
      seriesPizzaFilial: [],
      seriesColunaDia: [],
      seriesfilial: [],
      value_empresa: [], // [this.empresas],
      permissoes: [],
      permissao: {},

      mode: "save",
      carregando: false,
      atualizando: false,
      value_filial: [],
      value_status: [],
    };
  },

  methods: {
    loadEmpresa() {
      let params = {
        psg: this.user.psg,
        id_grupo_empresa: `${this.user.id_grupo_empresa}`,
      };

      const url = `${baseApiUrl}/ctr/empresa`;
      axios
        .get(url, { params })
        .then((res) => {
          this.empresas = res.data.map((emp) => {
            return {
              ...emp,
              value: emp.id_empresa,
              empresa: emp.nomeempresarial,
              id_filial_erp: emp.id_filial_erp,
            };
          });
        })
        .catch(showError);
    },

    loadFiliais() {
      let corpo = {
        id_grupo_empresa: `${this.user.id_grupo_empresa}`,
      };
      const url = `${baseApiUrl}/ctr/empresa/filial`;
      axios.post(url, corpo).then((res) => {
        this.filiaisf = res.data.map((filial) => {
          return { id_filial_erp: filial.id_filial_erp, filial: filial.filial };
        });
      });
    },

    loadStatus() {
      let corpo = {
        empresa_id: `${this.user.id_empresa}`,
      };
      const url = `${baseApiUrl}/pneu/status`;
      axios.get(url, corpo).then((res) => {
        this.statuss = res.data.map((tp) => {
          return { ...tp, value: tp.id, status: tp.status };
        });
      });
    },

    async loadKpiResumo() {
      let corpo = {
        empresa_id: `${this.empresaf.map((e) => e.id_empresa)}`,
        filial_id: `${this.filiaisf.map((f) => f.id_filial_erp)}`,
        status_id: `${this.sta.map((f) => f.id)}`,
        dt_inicial: `${this.dt_inicial}`,
        dt_final: `${this.dt_final}`,
        filtro: "resumo",
      };
      const url = `${baseApiUrl}/indicadores/pneus/kpi`;
      axios
        .post(url, corpo)
        .then((res) => {
          this.kpiresumo = res.data;
        })
        .catch(showError);
    },

    /// filtros por vida
    async loadKpiVida() {
      let corpo = {
        empresa_id: `${this.empresaf.map((e) => e.id_empresa)}`,
        filial_id: `${this.filiaisf.map((f) => f.id_filial_erp)}`,
        status_id: `${this.sta.map((f) => f.id)}`,
        dt_inicial: `${this.dt_inicial}`,
        dt_final: `${this.dt_final}`,
        filtro: "vida",
      };
      const url = await `${baseApiUrl}/indicadores/pneus/kpi`;
      axios
        .post(url, corpo)
        .then((res) => {
          this.kpividas = res.data;
          this.updateChartDataVida();
        })
        .catch(showError);
    },

    async updateChartDataVida() {
      this.seriesvidas = [
        {
          name: "Qtd vida",
          data: this.kpividas.map((item) => parseInt(item.qtd)),
        },
      ];
      this.$refs.chartvida.updateOptions({
        xaxis: {
          categories: this.kpividas.map((d) => d.vida),
        },
      });
    },

    async loadKpiMedida() {
      let corpo = {
        empresa_id: `${this.empresaf.map((e) => e.id_empresa)}`,
        filial_id: `${this.filiaisf.map((f) => f.id_filial_erp)}`,
        status_id: `${this.sta.map((f) => f.id)}`,
        dt_inicial: `${this.dt_inicial}`,
        dt_final: `${this.dt_final}`,
        filtro: "medida",
      };
      const url = await `${baseApiUrl}/indicadores/pneus/kpi`;
      axios
        .post(url, corpo)
        .then((res) => {
          this.kpimedidas = res.data;
          this.updateChartDataMedida();
        })
        .catch(showError);
    },

    async updateChartDataMedida() {
      this.seriesmedidas = [
        {
          name: "Qtd medida",
          data: this.kpimedidas.map((item) => parseInt(item.qtd)),
        },
      ];
      this.$refs.chartmedida.updateOptions({
        xaxis: {
          categories: this.kpimedidas.map((d) => d.medida),
        },
      });
    },

    async loadKpiBorracha() {
      let corpo = {
        empresa_id: `${this.empresaf.map((e) => e.id_empresa)}`,
        filial_id: `${this.filiaisf.map((f) => f.id_filial_erp)}`,
        status_id: `${this.sta.map((f) => f.id)}`,
        dt_inicial: `${this.dt_inicial}`,
        dt_final: `${this.dt_final}`,
        filtro: "borracha",
      };
      const url = await `${baseApiUrl}/indicadores/pneus/kpi`;
      axios
        .post(url, corpo)
        .then((res) => {
          this.kpiborrachas = res.data;
          this.updateChartDataBorracha();
        })
        .catch(showError);
    },

    async updateChartDataBorracha() {
      this.seriesborrachas = [
        {
          name: "Qtd borracha",
          data: this.kpiborrachas.map((item) => parseInt(item.qtd)),
        },
      ];
      this.$refs.chartborrachas.updateOptions({
        xaxis: {
          categories: this.kpiborrachas.map((d) => d.borracha),
        },
      });
    },

    async loadKpiFabricante() {
      let corpo = {
        empresa_id: `${this.empresaf.map((e) => e.id_empresa)}`,
        filial_id: `${this.filiaisf.map((f) => f.id_filial_erp)}`,
        status_id: `${this.sta.map((f) => f.id)}`,
        dt_inicial: `${this.dt_inicial}`,
        dt_final: `${this.dt_final}`,
        filtro: "fabricante",
      };
      const url = await `${baseApiUrl}/indicadores/pneus/kpi`;
      axios
        .post(url, corpo)
        .then((res) => {
          this.kpifabricantes = res.data;
          this.updateChartDataFabricante();
        })
        .catch(showError);
    },

    async updateChartDataFabricante() {
      this.seriesfabricantes = [
        {
          name: "Qtd fabricante",
          data: this.kpifabricantes.map((item) => parseInt(item.qtd)),
        },
      ];
      this.$refs.chartfabricante.updateOptions({
        xaxis: {
          categories: this.kpifabricantes.map((d) => d.fabricante),
        },
      });
    },

    async loadKpiStatus() {
      let corpo = {
        empresa_id: `${this.empresaf.map((e) => e.id_empresa)}`,
        filial_id: `${this.filiaisf.map((f) => f.id_filial_erp)}`,
        status_id: `${this.sta.map((f) => f.id)}`,
        dt_inicial: `${this.dt_inicial}`,
        dt_final: `${this.dt_final}`,
        filtro: "status",
      };
      const url = await `${baseApiUrl}/indicadores/pneus/kpi`;
      axios
        .post(url, corpo)
        .then((res) => {
          this.kpistatus = res.data;
          this.updateChartDataStatus();
        })
        .catch(showError);
    },

    async updateChartDataStatus() {
      this.seriesstatus = [
        {
          name: "Qtd status",
          data: this.kpistatus.map((item) => parseInt(item.qtd)),
        },
      ];
      this.$refs.chartstatus.updateOptions({
        xaxis: {
          categories: this.kpistatus.map((d) => d.status),
        },
      });
    },

    /// filtros por filial
    async loadKpiFilial() {
      let corpo = {
        empresa_id: `${this.empresaf.map((e) => e.id_empresa)}`,
        filial_id: `${this.filiaisf.map((f) => f.id_filial_erp)}`,
        status_id: `${this.sta.map((f) => f.id)}`,
        dt_inicial: `${this.dt_inicial}`,
        dt_final: `${this.dt_final}`,
        filtro: "filial",
      };
      const url = `${baseApiUrl}/indicadores/pneus/kpi`;
      axios
        .post(url, corpo)
        .then((res) => {
          this.kpifiliais = res.data;
          this.updateChartDataFilial();
        })
        .catch(showError);
    },

    async updateChartDataFilial() {
      this.graficoPizzaFilial.series = this.kpifiliais.map((item) =>
        parseInt(item.qtd)
      );
      this.atualizarLabels();
    },

    async atualizarLabels() {
      this.graficoPizzaFilial.labels = await this.kpifiliais.map(
        (item) => item.filial_id
      );
      this.$refs.chart.updateOptions({
        labels: this.graficoPizzaFilial.labels,
      });
    },
  },

  mounted() {
    this.loadEmpresas();
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
</style>